import { render, staticRenderFns } from "./VersionCount.vue?vue&type=template&id=b99b604a&scoped=true"
import script from "./VersionCount.vue?vue&type=script&lang=js"
export * from "./VersionCount.vue?vue&type=script&lang=js"
import style0 from "./VersionCount.vue?vue&type=style&index=0&id=b99b604a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b99b604a",
  null
  
)

export default component.exports